import React from 'react';
export function Footer() {
  return <footer className="bg-primary-bg py-8 md:py-12 px-4 border-t border-border-gold" data-id="element-55">
      <div className="max-w-4xl mx-auto text-center" data-id="element-56">
        <h2 className="font-heading text-lg md:text-2xl text-gold font-bold mb-4 md:mb-6 tracking-widest" data-id="element-57">
          CÓDIGO DE RESTAURACIÓN 24/7
        </h2>

        <p className="text-[10px] md:text-xs text-text-muted leading-relaxed max-w-2xl mx-auto mb-5 md:mb-8" data-id="element-58">
          Este producto es una guía de hábitos y organización personal. No
          reemplaza tratamiento médico, psicológico, legal ni financiero
          profesional. Los resultados pueden variar según la aplicación de cada
          individuo.
        </p>

        <div className="flex flex-wrap justify-center gap-3 md:gap-8 text-xs md:text-sm text-text-secondary font-medium mb-5 md:mb-8" data-id="element-59">
          <a href="#" className="hover:text-gold transition-colors" data-id="element-60">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-gold transition-colors" data-id="element-61">
            Política de Privacidad
          </a>
          <a href="#" className="hover:text-gold transition-colors" data-id="element-62">
            Contacto
          </a>
        </div>

        <p className="text-xs text-text-muted opacity-80" data-id="element-63">
          © 2026 — Todos los derechos reservados
        </p>
      </div>
    </footer>;
}